<div class="b2c-auth-wrapper">
  <div class="middle-box text-center animated fadeInDown">
    <div class="d-flex justify-content-center mb-3">
      <shared-ui-icons-icon [iconSize]="'9rem'" [iconName]="iconType.Lock"></shared-ui-icons-icon>
    </div>
    <h3 class="text-color fw-bold fs-1">{{ 'page-access-forbidden-title' | translate }}</h3>
    <div class="text-color">
      {{ 'page-access-forbidden-description' | translate }}
      <br />
      <br />
      <shared-ui-buttons-button [text]="'button-home' | translate" [type]="buttonType.Primary" [size]="buttonSize.Small" (action)="navigate()"></shared-ui-buttons-button>
    </div>
  </div>
</div>
